module.exports = require("@swa-ui/core/src/assets/styles/globalDefines.module.scss");